module.exports = __webpack_public_path__ + "img/logo01.946c75b8.png";